import './monitor'
import { createRoot } from 'react-dom/client'
import App from './App'

// import VConsole from 'vconsole'
// new VConsole()

window.load$ = new Promise<void>((resolve) => {
  const timeout = setTimeout(() => {
    resolve()
  }, 10000)

  window.addEventListener('load', () => {
    clearTimeout(timeout)
    resolve()
  })
})

Promise.all([
  import(/* webpackMode: "eager" */ './styles/index.scss'),
  import(/* webpackMode: "eager" */ 'dialog-polyfill/dist/dialog-polyfill.css'),
]).then(() => {
  createRoot(document.getElementById('App')).render(App())
})
